import { Box } from "@mui/material";
import React from "react";

const Badge = ({
    color,
    background,
    fontWeight,
    text,
    handleClick
}) => {
    return (
        <Box
            sx={{
                color: color,
                background: background,
                textAlign: 'center',
                padding: '4px 15px',
                borderRadius: 1,
                fontSize: 14,
                height: '30px',
                fontWeight: fontWeight,
                cursor: handleClick ? 'pointer' : 'arrow'
            }}
            onClick={(e) => {
                if(handleClick) handleClick(e);
            }}
        >
            {text}
        </Box>
    )
}

export default Badge;